


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



  const firebaseConfig = {
  apiKey: "AIzaSyBZsmGCsjC337XwrsL-UQPNetbb7VGoU64",
  authDomain: "crm-optical.firebaseapp.com",
  projectId: "crm-optical",
  storageBucket: "crm-optical.firebasestorage.app",
  messagingSenderId: "605733202596",
  appId: "1:605733202596:web:8b2baf737f5a63cbb9d431"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export